module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat_box"
  }, [_c('div', {
    staticClass: "chat-header"
  }, [_c('i', {
    staticClass: "el-icon-close pull-right close",
    staticStyle: {
      "margin": "5px"
    },
    on: {
      "click": function($event) {
        return _vm.setChatActive(false)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw back-icon",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('back')
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-user-circle-o fa-2x fa-fw left-icon",
    style: (_vm.contactColor),
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    style: (_vm.contactTextColor)
  }, [_vm._v(_vm._s(_vm.chatUser.userName))]), _vm._v(" "), _c('br'), _c('span', {
    staticClass: "company-text",
    style: (_vm.contactTextColor)
  }, [_vm._v(_vm._s(_vm.chatUser.company || '-'))])]), _vm._v(" "), _c('div', {
    ref: "msgWrapper",
    staticClass: "chat_message_wrapper"
  }, [_vm._l((_vm.msges), function(msg, i) {
    return _c('div', {
      key: msg.timestamp + msg.fromUserId + msg.toUserId,
      staticClass: "message_wrap"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.fromMe(msg) && (i === 0 || _vm.msges[i - 1].fromUserId !== msg.fromUserId)),
        expression: "fromMe(msg) && (i === 0 || msges[i-1].fromUserId !== msg.fromUserId)"
      }],
      staticClass: "name me"
    }, [_vm._v("\n          me\n        ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.fromMe(msg)),
        expression: "fromMe(msg)"
      }],
      staticClass: "chat_message me"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(msg.msg)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.getDateString(msg.timestamp)) + "\n            "), (msg.readTimestamp && msg.readTimestamp !== '') ? _c('i', {
      staticClass: "fa fa-check read-tick",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.fromMe(msg) && (i === 0 || _vm.msges[i - 1].toUserId !== msg.toUserId)),
        expression: "!fromMe(msg) && (i === 0 || msges[i-1].toUserId !== msg.toUserId)"
      }],
      staticClass: "name other"
    }, [_vm._v("\n          " + _vm._s(_vm.chatUser.userName) + "\n        ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.fromMe(msg)),
        expression: "!fromMe(msg)"
      }],
      staticClass: "chat_message other"
    }, [_c('div', {
      staticClass: "centralise",
      domProps: {
        "innerHTML": _vm._s(msg.msg)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(_vm.getDateString(msg.timestamp)))])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.choices.length > 0),
      expression: "choices.length > 0"
    }]
  }, _vm._l((_vm.choices), function(c) {
    return _c('button', {
      staticClass: "choices",
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.selectChoice(c)
        }
      }
    }, [_vm._v(_vm._s(c))])
  }), 0)], 2), _vm._v(" "), _c('div', {
    staticClass: "chat_submit_box"
  }, [_c('div', {
    staticClass: "uk-input-group"
  }, [_c('div', {
    staticClass: "gurdeep-chat-box"
  }, [_c('input', {
    ref: "textInput",
    staticClass: "md-input",
    attrs: {
      "type": "text",
      "placeholder": "Type a message",
      "id": "submit_message",
      "name": "submit_message",
      "autofocus": ""
    },
    domProps: {
      "value": _vm.tmsg
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendNewMsg($event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "8px",
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.speechClass,
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.recordVoice
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d22733c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chat.vue
// module id = 607
// module chunks = 34